import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import Index from "./pages/Index.tsx";
import Bio from "./pages/Bio.tsx";
import NotFound from "./pages/NotFound.tsx";
import { useConnectivity } from "@/hooks/use-connectivity";

const OfflineBar = () => {
  const isOffline = useConnectivity();
  
  if (!isOffline) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-primary text-white text-center h-8 flex items-center justify-center text-xs font-body font-semibold animate-in fade-in slide-in-from-top duration-300 shadow-sm box-border">
      Você está visualizando uma versão offline.
    </div>
  );
};

const App = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <OfflineBar />
    <Sonner />
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/bio" element={<Bio />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default App;
